import Dashboard from './Dashboard.vue'
import AppContainer from '@/container/AppContainer.vue';

export const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: AppContainer,
        children: [
            {
                path: '/',
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            }
        ]
    }
]
